export const HOST = 'https://product-catalog-api-0h4z.onrender.com/';
